import ALYX_STATES from 'a/components/GameHeader/AlexStates';

import {
  SET_SCREEN,
  SET_ALYX_STATE,
  START_ROUND,
  EXIT_ROUND,
  INCREMENT_STANDARD_ROUND,
  START_PRACTICE,
  EXIT_PRACTICE,
  INCREMENT_PRACTICE_ROUND,
  INCREMENT_TOTAL_CORRECT,
  COMPLETE_LEVEL,
  ASK_FOR_HELP,
} from '../ActionTypes';
import { GAME_ID, SCREENS } from '../../constants';

const initialState = {
  screen: SCREENS.PROGRESS,
  alyxState: ALYX_STATES.INACTIVE,
  lastLevelUnlocked: 0,
  levelIndex: 0,
  sides: [],
  standardRoundIndex: 0,
  standardRoundOrder: [],
  totalCorrect: 0,
  // the keys for these are connectives because each connective has multiple
  // sets of practice items to cycle through
  practiceSetIndices: {},
  practiceRoundIndex: 0,
  helpIndex: 0,
};

export default (state = initialState, { gameId, type, payload = {} }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case SET_SCREEN:
      return {
        ...state,
        screen: payload.screen,
      };
    case SET_ALYX_STATE:
      return {
        ...state,
        alyxState: payload.alyxState,
      };
    case START_ROUND:
      return {
        ...state,
        levelIndex: payload.levelIndex,
        sides: state.sides.length === 0 ? Array(payload.levelsMax).fill(true) : state.sides,
        standardRoundIndex: 0,
        standardRoundOrder: payload.standardRoundOrder,
        totalCorrect: 0,
        practiceRoundIndex: 0,
      };
    case EXIT_ROUND: {
      const sides = [...state.sides];
      sides[state.levelIndex] = !sides[state.levelIndex];
      return {
        ...state,
        sides,
        levelIndex: 0,
        standardRoundIndex: 0,
        standardRoundOrder: [],
        totalCorrect: 0,
        practiceRoundIndex: 0,
      };
    }
    case INCREMENT_STANDARD_ROUND:
      return {
        ...state,
        standardRoundIndex: state.standardRoundIndex + 1,
        totalCorrect: payload.isCorrect ? state.totalCorrect + 1 : state.totalCorrect,
        helpIndex: 0,
      };
    case START_PRACTICE:
      return {
        ...state,
        // make sure a key exists for the practice round connective, but do not
        // overwrite it if it already does
        practiceSetIndices: { [payload.connective]: 0, ...state.practiceRoundIndices },
        practiceRoundIndex: 0,
      };
    case EXIT_PRACTICE:
      return {
        ...state,
        practiceSetIndices: { ...state.practiceSetIndices, [payload.connective]: payload.practiceSetIndex },
        practiceRoundIndex: 0,
        helpIndex: 0,
      };
    case INCREMENT_PRACTICE_ROUND:
      return {
        ...state,
        practiceRoundIndex: state.practiceRoundIndex + 1,
        helpIndex: 0,
      };
    case INCREMENT_TOTAL_CORRECT:
      return {
        ...state,
        totalCorrect: payload.isCorrect ? state.totalCorrect + 1 : state.totalCorrect,
      };
    case COMPLETE_LEVEL: {
      const sides = [...state.sides];
      sides[state.levelIndex] = !sides[state.levelIndex];
      return {
        ...state,
        sides,
        levelIndex: 0,
        standardRoundIndex: 0,
        standardRoundOrder: [],
        totalCorrect: 0,
        practiceRoundIndex: 0,
        lastLevelUnlocked: payload.isSuccess
          // <ProgressScreen /> takes 0 index
          ? Math.min(state.levelIndex + 1, sides.length - 1)
          // highlight level we just played
          : state.levelIndex,
      };
    }
    case ASK_FOR_HELP: {
      return { ...state, helpIndex: state.helpIndex + 1 };
    }
    default:
      return state;
  }
};
